export default __webpack_public_path__ + "static/media/virtual-bg23.c1cd18bb.png";